// extracted by mini-css-extract-plugin
export var grid = "language-selector-module--grid--7c0e7";
export var gridWithRowGap = "language-selector-module--grid--with-row-gap--e5de5";
export var languageSelector = "language-selector-module--language-selector--5cb26";
export var languageSelector__item = "language-selector-module--language-selector__item--515a2";
export var languageSelector__itemFocus = "language-selector-module--language-selector__item--focus--72b3e";
export var languageSelector__itemSelected = "language-selector-module--language-selector__item--selected--9dad3";
export var maxWidthContainer = "language-selector-module--max-width-container--d2ab5";
export var mt0 = "language-selector-module--mt-0--3af49";
export var mt1 = "language-selector-module--mt-1--cdef7";
export var mt2 = "language-selector-module--mt-2--af521";
export var mt3 = "language-selector-module--mt-3--b880a";
export var mt4 = "language-selector-module--mt-4--36181";
export var mt5 = "language-selector-module--mt-5--7d15d";
export var mt6 = "language-selector-module--mt-6--49eef";
export var removeVisuallyHidden = "language-selector-module--remove-visually-hidden--fc978";
export var visuallyHidden = "language-selector-module--visually-hidden--0e383";
export var widgetBase = "language-selector-module--widget-base--7963f";